import React, { useRef, useState, useEffect } from "react";
import { IQ_HUB_AUTH_SERVICES, IQ_HUB_USER_DETAILS } from "../../services";
import { appConstants } from "../../utils";
import { showToast } from "../../components/ToastComponent";
import AuthView from "../../components/AuthView";
import * as constant from "../../utils/constants";
import { useNavigate } from "react-router-dom";

const AUTH_ALLOWED_PATHS = [
  constant.APP_ROUTE_LOGIN,
  constant.APP_ROUTE_FORGOT_PASSWORD,
  constant.APP_ROUTE_SIGNUP,
];
const Authenticate = ({
  content = {},
  defaultRedirectPath = "/",
  AppLoader,
  stopGlobalLoader,
  AppComponent,
  AppComponentProps,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [userData, setUserData] = useState(null);
  const redirectPathRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    const redirectPath = window.location.pathname;
    if (redirectPath && !AUTH_ALLOWED_PATHS.includes(redirectPath)) {
      redirectPathRef.current = redirectPath;
    }

    const LoginRequiredHandler = async (e) => {
      const token = localStorage.getItem(appConstants.IQ_HUB_TOKEN_NAME);
      if (token) {
        try {
          const response = await IQ_HUB_AUTH_SERVICES.Logout();
          const { message } = await response.json();
          showToast(message);
        } catch (e) {
          console.error(e.message);
        }
      }
      localStorage.removeItem(appConstants.IQ_HUB_TOKEN_NAME);
      setUserData(null);
      // redirect to authentication
    };

    window.addEventListener("IQ_LOGIN_REQUIRED", LoginRequiredHandler);

    let isAPITriggered = false;
    async function checkUserLogIn() {
      const userDetails = await IQ_HUB_USER_DETAILS.userInfo();
      if (!isAPITriggered) {
        if (userDetails) {
          setUserData(userDetails);
          // onLoginSuccess(redirectPathRef.current);
          navigate(redirectPathRef?.current ?? defaultRedirectPath);

          // redirect to dashboard;
        } else {
          // triggering stopGlobalLoader only when userData is not present ( in order to show login page )
          if (stopGlobalLoader) {
            stopGlobalLoader();
          }
        }
        setIsLoading(false);
      }
    }

    checkUserLogIn();

    return () => {
      window.removeEventListener("IQ_LOGIN_REQUIRED", LoginRequiredHandler);
      isAPITriggered = true;
    };
  }, []);

  if (isLoading) {
    return AppLoader && <AppLoader />;
  }

  if (userData) {
    return AppComponent ? (
      <AppComponent {...AppComponentProps} userData={userData} />
    ) : (
      <h2>Application Component is not passed</h2>
    );
  }

  return (
    <AuthView
      // onLoginSuccess={onLoginSuccess}
      content={content}
      redirectPath={redirectPathRef.current}
      defaultRedirectPath={defaultRedirectPath}
      setUserData={setUserData}
    />
  );
};

export default Authenticate;
